import { render } from "./FormAge.vue?vue&type=template&id=664dd29d&ts=true"
import script from "./FormAge.vue?vue&type=script&lang=ts"
export * from "./FormAge.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/hubevt/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__